import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const CreateIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
			{...props?.innerSvgProps}
		>
			<path
				d='M10 12.5H7.5V10L15 2.5L17.5 5L10 12.5Z'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.125 4.375L15.625 6.875'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M16.875 9.375V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V3.75C3.125 3.58424 3.19085 3.42527 3.30806 3.30806C3.42527 3.19085 3.58424 3.125 3.75 3.125H10.625'
				// This is the correct code and color for the Select component.
				stroke={props?.color || colors.indigo70}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CreateIcon;
